import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import { LoaderContainer } from '../components/atoms/LoaderContainer';
import useProductAvailability from '../hooks/useProductAvailability';

type Props = {
  redirect?: string;
};

const SportsbookAccessGuard = ({ redirect = '/casino', children }: PropsWithChildren<Props>) => {
  const { hasSportsbookAccess, isProductAvailabilityResolved } = useProductAvailability();

  if (!isProductAvailabilityResolved) {
    return <LoaderContainer />;
  }

  if (!hasSportsbookAccess) {
    return <Navigate to={redirect} replace />;
  }

  return <>{children}</>;
};

export default SportsbookAccessGuard;
